import { injectable } from 'tsyringe'
import { GalleryImageApiRepository } from '@/app/repositories/api/GalleryImageRepository'
import { Image } from '@/domain/entities/GalleryImage'
import {
  PostGalleryImageInterface,
  DeleteGalleryImageInterface,
} from '@/data/payload/contracts/GalleryImageRequest'
@injectable()
export class GalleryImagePresenter {
  private repository: GalleryImageApiRepository

  constructor(repository: GalleryImageApiRepository) {
    this.repository = repository
  }

  public loadGalleryImage(params: Object): Promise<Image> {
    return this.repository.getAll(params)
  }

  public postGalleryImage(payload: PostGalleryImageInterface): Promise<Image> {
    return this.repository.post(payload)
  }

  public deleteGalleryImage(
    payload: DeleteGalleryImageInterface
  ): Promise<Image> {
    return this.repository.delete(payload)
  }
}
